import React, {useContext, useEffect, useState} from "react";
import "components/Content/Toolbar/CSS Files/tooglebar.css"
import "components/Content/Toolbar/CSS Files/Toolbar.css"
import {SliderPicker} from "react-color";
import {CreationContext} from "../../../containers/Content/CreationSuite";


export function BackgroundLoader(props) {
    const {value, value2} = useContext(CreationContext);
    const [backgroundFill, setBackgroundFill] = value2;
    const [creationCanvas, setCreationCanvas] = value;



    const handleSliderChange = (color) => {

        setBackgroundFill(color.hex);

    }

    useEffect(() => {

        creationCanvas.backgroundColor = backgroundFill;
        creationCanvas.renderAll();
    })


    return(
        <SliderPicker
            style = {{width : "400px", height: "200px"}}
            color = {backgroundFill}
            onChange = {handleSliderChange}
            value = {backgroundFill}/>
    );
}

class Background extends React.Component {

    render() {
        return (
            <div className="sidebar">
                <div className = "background-selection">
                    <BackgroundLoader/>
                </div>
            </div>
        );

    }
}

export default Background;